export default __webpack_public_path__ + "static/media/pantry1-afterB-1920w.75edb27c.webp";